<template>
  <div>
    <footer
      v-if="data.showFooter"
      class="rn-footer footer-style-default footer-style-1"
    >
      <div class="footer-top" style="padding: 32px 0px;">
        <div class="container">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div style="width: 430px">
              <div style="margin-bottom: 23px">
                <img :src="logo" style="width: 68px; height: 39px" />
              </div>
              <div
                style="
                  font-size: 20px;
                  font-weight: 500;
                  color: rgba(255, 255, 255, 0.9);
                  line-height: 108.5%;
                "
              >
                Optimism native liquidity release protocol & governance hub.
              </div>
              <div
                style="
                  margin: 28px 0px;
                  font-weight: 400;
                  color: rgba(255, 255, 255, 0.72);
                  line-height: 120.5%;
                "
              >
                Build around Velodrome Finance ecosystem, offering users instant
                veVELO NFT-backed loans and easier access to velodrome Finance
                governance power.
              </div>
              <div style="color: white; font-weight: 500">
                Please contact us via: augustaprotocol@gmail.com
              </div>
            </div>
            <div style="width: 346px">
              <div
                style="
                  font-weight: 500;
                  color: rgba(255, 255, 255, 0.6);
                  font-size: 20px;
                  margin-bottom: 20px;
                "
              >
                Join the community
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  font-weight: 400;
                  color: rgba(255, 255, 255, 0.39);
                  font-size: 20px;
                  margin-bottom: 20px;
                "
              >
                <div>Community</div>
                <div>Resources</div>
              </div>
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  color: #fff;
                  font-size: 20px;
                  font-weight: 400;
                  margin-bottom: 14px;
                "
              >
                <div>
                  <a href="https://twitter.com/Augusta_finance">
                    <img
                      style="width: 46px; height: 46px; margin-right: 20px"
                      src="../../../assets/images/icons/twitter-w.svg"
                      alt="Twitter"
                    />Twitter
                  </a>
                </div>
                <div style="margin-right: 53px;">
                  <a href="https://augusta-finance.gitbook.io">Doc</a>
                </div>
              </div>
              <div style="color: #fff; font-size: 20px; font-weight: 400">
                <a href="https://discord.gg/Pk6n6RSy">
                  <img
                    style="width: 46px; height: 46px; margin-right: 20px"
                    src="../../../assets/images/icons/discord-w.svg"
                    alt="Discord"
                  />Discord
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <ScrollTop />
  </div>
</template>

<script>
import CopyrightTwo from './CopyrightTwo'
import CallToAction from '../../elements/callToAction/CallToAction'
import ScrollTop from './ScrollTop'

export default {
  name: 'FooterTwo',
  components: { CallToAction, CopyrightTwo, ScrollTop },
  props: {
    data: {
      default: null,
    },
  },
  data() {
    return {
      logo: require('../../../assets/images/logo/logo.png'),
    }
  },
}
</script>
